<div class="root"
  (mouseenter)="onHover(true)" 
  (mouseleave)="onHover(false)"
  (click)="emitClick()">
  <div class="content-container">
    <div class="title-container">
      <app-lucide-icon [iconName]="iconName" [size]="36" [color]="hoverColor"></app-lucide-icon>
      <span class="title">{{ title }}</span>
    </div>
    <span class="description">{{ description }}</span>
    <app-lucide-icon class="move-right" iconName="move-right" [color]="hoverColor"></app-lucide-icon>
  </div>
</div>
